import type { ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
  children: ReactNode;
  /** When true, the overlay is rendered without the group-hover opacity gate. */
  alwaysVisible?: boolean;
  /**
   * JS-controlled visibility. When provided, bypasses group-hover entirely —
   * opacity is driven purely by this value. Use when the parent manages
   * show/hide logic (e.g. video auto-hide on play).
   */
  visible?: boolean;
  /** Override vertical offset from the bottom of the parent. */
  bottomClassName?: string;
  className?: string;
}

export function HoverControlsPill({
  children,
  alwaysVisible = false,
  visible,
  bottomClassName = 'bottom-4',
  className,
}: Props) {
  const opacityClass =
    visible !== undefined
      ? visible
        ? 'opacity-100'
        : 'opacity-0'
      : alwaysVisible
        ? 'opacity-100'
        : 'opacity-0 group-hover:opacity-100 focus-within:opacity-100';

  return (
    <div
      className={clsx(
        'pointer-events-none absolute left-4 z-10 flex items-center gap-2 transition-opacity duration-fast',
        bottomClassName,
        opacityClass,
        className,
      )}
    >
      {children}
    </div>
  );
}
